module.exports = __webpack_public_path__ + "img/exit_intent.645d3ea0.jpg";